import type { DeepPartial } from '@luna/utils-ts';

import type { LoanFeatureConfig } from '../types/LoanFeatureConfig';

export const loans: DeepPartial<LoanFeatureConfig> = {
    overview: {
        enabled: true,
        showTransactions: true,
        showLoanCurrency: true,
        displayDedicatedMortgageInfos: true,
    },
    additionalDetails: {
        showOverdueInfo: true,
        showExtraInstallment: true,
    },
    transactions: {
        enabled: true,
        mode: 'always',
    },
    statements: {
        enabled: true,
        showMultiDownloadCard: true,
        showDownloadOptions: true,
    },
    settingsDetails: {
        displayAccountOwner: true,
        displayIban: true,
        displayBIC: true,
    },
    layout: {
        productInfo: {
            formatAccountNumber: true,
        },
    },
};
